<template>
  <div class="model-select">
    <div>
      <a-checkbox-group v-model="contractLyMessage" @change="onChangeCheckbox">
        <a-checkbox v-for="item in contactMessageList" :key="item.value" :disabled="item.value=='1'||item.value=='2'"
                    :value="item.value">
          {{ item.label }}
          <span class="color-span" v-if="item.isRequired">[必填]</span>
        </a-checkbox>
      </a-checkbox-group>
    </div>
    <a-select v-model="linkmanInfoId" placeholder="请选择" style="max-width:250px;">
      <a-select-option v-for="item in linkmanList" :key="item.value" :value="item.value">{{ item.label }}
      </a-select-option>
    </a-select>&nbsp;&nbsp;&nbsp;
    <a-checkbox v-model="isRequired">必填</a-checkbox>
    <a-button :disabled="isDisabled" @click="onAddEvent">添加</a-button>
  </div>
</template>

<script>
export default {
  name: 'LinkmanItem',
  props: {
    isDisabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      optionLyTouristSelct: [],
      contractLyMessage: [],
      contactMessageList: [
        {
          label: '姓名',
          value: '1'
        },
        {
          label: '电话',
          value: '2'
        }
      ],
      linkmanList: [
        {
          label: '邮箱',
          value: '3'
        },
        {
          label: '收货地址',
          value: '4'
        },
        {
          label: '身份证号',
          value: '6'
        },
        {
          label: 'QQ号',
          value: '10'
        },
        {
          label: '微信',
          value: '11'
        }
      ],
      linkmanInfoId: '10',
      isRequired: false
    }
  },
  mounted() {
  },
  methods: {
    onChangeCheckbox(checkedValues) {
      this.getLogUtils().logWithTag('onChangeCheckbox', checkedValues)
      this.contractLyMessage = checkedValues
      this.getLogUtils().logWithTag('this.optionLyTouristSelct', this.optionLyTouristSelct)
      let arr = []
      this.contractLyMessage.forEach(item => {
        this.optionLyTouristSelct.forEach(item2 => {
          if (item == item2) {
            arr.push(item2)
          }
        })
      })
      let obj = {
        str: this.contractLyMessage.join(','),
        requiredStr: arr.length > 0 ? arr.join(',') : ''
      }
      this.$emit('change', obj)
    },
    onAddEvent() {
      let linLabel = ''
      try {
        linLabel = this.linkmanList.filter(item => {
          return item.value == this.linkmanInfoId
        })[0].label
      } catch (error) {
        this.getLogUtils().logWithTag('联系人人', '错误')
      }
      let objPerson = {
        label: linLabel,
        value: this.linkmanInfoId,
        isRequired: this.isRequired
      }
      this.getLogUtils().logWithTag('onAddEvent', objPerson)
      let flag = true
      this.contactMessageList.forEach((item, index) => {
        if (item.value == objPerson.value) {
          this.contactMessageList.splice(index, 1, objPerson)
          flag = false
        }
      })
      if (flag) {
        this.contactMessageList.push(objPerson)
        this.contractLyMessage.push(objPerson.value)
      }
      this.getLogUtils().logWithTag('onAddEvent==contractLyMessage', this.contractLyMessage)
      let arr1 = []
      let arr2 = []
      this.contactMessageList.forEach(item => {
        arr1.push(item.value)
        if (item.isRequired) {
          arr2.push(item.value)
        }
      })
      let obj = {
        str: arr1.join(','),
        requiredStr: arr2.length > 0 ? arr2.join(',') : ''
      }
      this.optionLyTouristSelct = arr2
      this.$emit('change', obj)
    },
    // 回显信息
    getLinkInfo(linkStr, mustStr) {
      this.contractLyMessage = linkStr && linkStr != '' ? linkStr.split(',') : ['1', '2']
      this.optionLyTouristSelct = mustStr && mustStr != '' ? mustStr.split(',') : []
      let arr = []
      this.linkmanList.forEach(item => {
        this.contractLyMessage.forEach(sItem => {
          if (item.value == sItem) {
            arr.push(item)
          }
        })
      })
      this.getLogUtils().logWithTag('getLinkInfo', arr)
      this.contactMessageList = this.contactMessageList.concat(arr)
      if (this.optionLyTouristSelct.length > 0) {
        this.contactMessageList.forEach((item) => {
          this.optionLyTouristSelct.forEach(item2 => {
            if (item.value == item2) {
              this.$set(item, 'isRequired', true)
            }
          })
        })
      }
      this.getLogUtils().logWithTag('getLinkInfo----contactMessageList', this.contactMessageList)
      let obj = {
        str: this.contractLyMessage.join(','),
        requiredStr: this.optionLyTouristSelct.length > 0 ? this.optionLyTouristSelct.join(',') : ''
      }
      this.$emit('change', obj)
    }
  }

}
</script>
<style lang="less" scoped>
.color-span {
  color: #FAAD14;
}
</style>